import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const TenantContext = createContext();

export const useTenantContext = () => {
    return useContext(TenantContext);
};

export const TenantProvider = ({ children }) => {
    const [tenantProfile, setTenantProfile] = useState({
        tenant_name: "PeopleHub",
        logo_url: "/logo.png",
        primary_color: "#4338ca"
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProfile = async () => {
            try {
                // Fetch the global tenant profile
                const tenantHeader = { "X-Tenant": localStorage.getItem("tenant") || "" };
                const res = await axios.get(`${process.env.REACT_APP_API_URL1}/system/tenant-profile`, { headers: tenantHeader });
                if (res.data?.success && res.data?.data) {
                    setTenantProfile(res.data.data);
                }
            } catch (err) {
                console.error("Failed to fetch tenant profile:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchProfile();
    }, []);

    const refreshProfile = async () => {
        setLoading(true);
        try {
            const tenantHeader = { "X-Tenant": localStorage.getItem("tenant") || "" };
            const res = await axios.get(`${process.env.REACT_APP_API_URL1}/system/tenant-profile`, { headers: tenantHeader });
            if (res.data?.success && res.data?.data) {
                setTenantProfile(res.data.data);
            }
        } catch (err) {
            console.error("Failed to fetch tenant profile:", err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <TenantContext.Provider value={{ tenantProfile, loading, refreshProfile }}>
            {children}
        </TenantContext.Provider>
    );
};
